import { AddressResult, IGeocodingProvider } from '../../domain/providers/IGeocodingProvider'
import axios, { AxiosInstance, AxiosRequestConfig } from 'axios'
import { WoosmapGeocodingData, WoosmapGeocodingResult } from './woosmapSdk'

class WoosmapGeocodingProvider implements IGeocodingProvider {
  public http: AxiosInstance
  public woosmapKey: string

  constructor(woosmapKey: string) {
    const config: AxiosRequestConfig = {
      baseURL: 'https://api.woosmap.com',
      headers: {
        'content-type': 'application/json'
      }
    }
    this.http = axios.create(config)
    this.woosmapKey = woosmapKey
  }

  private static toAddressResult({
                                   address_components,
                                   formatted_address,
                                   geometry
                                 }: WoosmapGeocodingResult): AddressResult {

    const route = address_components.find(it => it.types.includes('route'))
    const number = address_components.find(it => it.types.includes('street_number'))
    const city = address_components.find(it => it.types.includes('locality'))
    const country = address_components.find(it => it.types.includes('country'))
    const zipCode = address_components.find(it => it.types.includes('postal_code'))


    const line = `${number?.long_name || ''} ${route?.long_name || ''}`.trim()

    return {
      formattedAddress: formatted_address,
      line: line,
      city: city?.long_name,
      country: country?.long_name,
      zipCode: zipCode?.long_name,
      latitude: geometry.location.lat,
      longitude: geometry.location.lng
    }
  }

  async getAddressFromCoordinates(latitude: number, longitude: number): Promise<Array<AddressResult>> {
    const { data } = await this.http.get<WoosmapGeocodingData>('address/geocode/json', {
      params: {
        latlng: `${latitude},${longitude}`,
        key: this.woosmapKey
      }
    })
    return data.results.map(it => WoosmapGeocodingProvider.toAddressResult(it))
  }

  async getAddressFromAddress(address: string): Promise<Array<AddressResult>> {
    const { data } = await this.http.get<WoosmapGeocodingData>('address/geocode/json', {
      params: {
        address,
        key: this.woosmapKey
      }
    })
    return data.results.map(it => WoosmapGeocodingProvider.toAddressResult(it))
  }


}


export default WoosmapGeocodingProvider
